var map = {
	"./E.svg": 4791,
	"./ENE.svg": 2905,
	"./ESE.svg": 6720,
	"./N.svg": 7750,
	"./NE.svg": 9313,
	"./NNE.svg": 1545,
	"./NNW.svg": 8577,
	"./NW.svg": 2775,
	"./Rain-Icon-Blue.svg": 9849,
	"./Rain-Icon-Grey.svg": 3884,
	"./S.svg": 6307,
	"./SE.svg": 4346,
	"./SSE.svg": 3717,
	"./SSW.svg": 8474,
	"./SW.svg": 3019,
	"./VRB.svg": 8659,
	"./W.svg": 4113,
	"./WNW.svg": 1430,
	"./WSW.svg": 2739,
	"./blank.svg": 756,
	"./jersey-wind-east.svg": 6044,
	"./jersey-wind-north-east.svg": 8101,
	"./jersey-wind-north-west.svg": 7064,
	"./jersey-wind-north.svg": 5345,
	"./jersey-wind-south-east.svg": 6148,
	"./jersey-wind-south-west.svg": 6635,
	"./jersey-wind-south.svg": 6145,
	"./jersey-wind-west.svg": 2406,
	"./null.svg": 9588
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;